import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { lastValueFrom } from "rxjs";
import { BaseServiceService } from "src/app/services/base-service.service";
import { AppData } from "src/app/helpers/app-data";
import {
  ModalNotifyComponent,
  ModalNotifyTypes,
} from "../modal-notify/modal-notify.component";

@Component({
  selector: "app-datatable-banco-procesos",
  templateUrl: "./datatable-banco-procesos.component.html",
  styleUrl: "./datatable-banco-procesos.component.css",
})
export class DatatableBancoProcesosComponent implements OnInit {
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  getDataTableCatalogProcess: any = ["CatalogProcess", "GetDataTableCatalogProcess"];

  dtInstance: DataTables.Api;
  dtOptButtons: any = [];

  columnas = [
    { title: "Nombre", data: "Nombre" },
    { title: "Descripcion", data: "Descripcion" },
    { title: "Objetivo", data: "Objetivo" },
    { title: "Alcance", data: "Alcance" },
    { title: "Tipo Proceso", data: "TipoProceso" },
    { title: "Industria", data: "Industria" },
    { title: "Estado", data: "Estado" },
    { title: "Version", data: "Version" },
    { title: "Fecha Actualización", data: "FechaActualizacionProceso" },
  ];

  idCatalogProcess: any;
  nombreCatalogProcess: string;
  botonProcesando: boolean = false;

  // Ver Diagrama (mismo mecanismo que datatable-procesos: reutiliza app-generic-modal + app-diagram-viewer)
  modalDiagramaVisible: boolean = false;
  mostrarDiagrama: boolean = false;
  xmlContent: string = "";
  idCatalogProcessTitle?: number;
  nombreCatalogProcessTitle?: string;

  constructor(
    private baseService: BaseServiceService,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.dtOptButtons.push(
      {
        "button-id": "btnVerDiagramaCatalogProcess",
        "button-icon": "ms-Icon--RedEye",
        "button-tooltip": "Ver Diagrama",
        "conditional-data": [{ key: "field", value: "Nombre" }],
      },
      {
        "button-id": "btnExportarCatalogProcess",
        "button-icon": "ms-Icon--Download",
        "button-tooltip": "Exportar",
        "conditional-data": [{ key: "field", value: "Nombre" }],
      },
      {
        "button-id": "btnUsarProceso",
        "button-icon": "ms-Icon--PageAdd",
        "button-tooltip": "Usar proceso",
        "conditional-data": [{ key: "field", value: "Nombre" }],
      }
    );
  }

  gridLoaded(event: any) {
    this.dtInstance = event["table"];
  }

  customClick(event: any) {
    this.idCatalogProcess = event["data-id"];
    this.nombreCatalogProcess = event["data-field"];

    switch (event["button-id"]) {
      case "btnVerDiagramaCatalogProcess":
        this.nombreCatalogProcessTitle = event["data-field"];
        this.idCatalogProcessTitle = this.idCatalogProcess;
        this.cargarDiagramaCatalogProcess();
        break;
      case "btnExportarCatalogProcess":
        this.exportarCatalogProcess();
        break;
      case "btnUsarProceso":
        this.confirmarUsarProceso();
        break;
    }
  }

  // Reutiliza exactamente el mismo flujo de "Ver Diagrama" de datatable-procesos.component.ts,
  // apuntando al endpoint de solo lectura del catálogo (CatalogProcess/GetCatalogProcessConfiguracion).
  async cargarDiagramaCatalogProcess() {
    try {
      this.mostrarDiagrama = false;
      this.modalDiagramaVisible = true;

      const headers = {
        "X-APIKey": AppData.API_KEY,
        Authorization: "Bearer " + sessionStorage.getItem(AppData.localStorageToken),
      };

      const response = await lastValueFrom(
        this.http.get<any>(
          `${AppData.API_URL}CatalogProcess/GetCatalogProcessConfiguracion?Id=${this.idCatalogProcess}`,
          { headers }
        )
      );

      if (response && response.Data && response.Data.Configuracion) {
        this.xmlContent = response.Data.Configuracion;
        this.mostrarDiagrama = true;
      } else {
        this.baseService.triggerShowModal(
          "Error",
          "No se pudo cargar el diagrama del proceso.",
          ModalNotifyTypes.Danger,
          false
        );
        this.cerrarModalDiagrama();
      }
    } catch (error) {
      console.error("Error al cargar diagrama del catálogo:", error);
      this.baseService.triggerShowModal(
        "Error",
        "Error al cargar el diagrama del proceso.",
        ModalNotifyTypes.Danger,
        false
      );
      this.cerrarModalDiagrama();
    }
  }

  cerrarModalDiagrama() {
    this.modalDiagramaVisible = false;
    this.mostrarDiagrama = false;
    this.xmlContent = "";
  }

  // Reutiliza exactamente el mismo flujo de "Exportar" de datatable-procesos.component.ts
  // (descarga el XML como .bpmn), apuntando al endpoint de solo lectura del catálogo.
  async exportarCatalogProcess() {
    if (this.idCatalogProcess === null || this.idCatalogProcess === undefined) {
      return;
    }

    try {
      const responseById = await this.baseService.getById(
        "CatalogProcess/GetCatalogProcessConfiguracion",
        this.idCatalogProcess
      );

      if (!responseById.Ok || !responseById.Data || !responseById.Data.Configuracion) {
        this.baseService.triggerShowModal(
          "Error al exportar",
          "No se pudo exportar el proceso del catálogo.",
          ModalNotifyTypes.Danger,
          false
        );
        return;
      }

      const xmlData = responseById.Data.Configuracion.trim();
      const blob = new Blob([xmlData], { type: "text/xml;charset=utf-8" });

      const link = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${responseById.Data.Nombre || "proceso-biblioteca"}.bpmn`);
      link.style.display = "none";

      document.body.appendChild(link);

      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 0);
    } catch (error) {
      console.error("Error al exportar el proceso del catálogo:", error);
      this.baseService.triggerShowModal(
        "Error al exportar",
        "Ocurrió un error al exportar el proceso del catálogo.",
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  // Modal de confirmación (reutiliza el sistema de notificaciones existente, RF-09) antes de clonar.
  confirmarUsarProceso() {
    this.baseService.triggerShowModal(
      "Usar proceso",
      `¿Deseas usar el proceso "${this.nombreCatalogProcess}"? Se creará una copia en tu espacio de trabajo dentro de Diseño de Procesos.`,
      ModalNotifyTypes.Warning,
      true
    );

    this.modalNotifyComponent.actionConfirmed.subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.usarProceso();
      }
    });
  }

  // Invoca el Deep Copy en el backend y, tras el éxito, redirige a "Diseño de Procesos".
  async usarProceso() {
    this.botonProcesando = true;
    try {
      const response = await lastValueFrom(
        this.http.post<any>(
          `${AppData.API_URL}CatalogProcess/CloneProcessToWorkspace?Id=${this.idCatalogProcess}`,
          null
        )
      );

      if (!response.Ok) {
        this.baseService.triggerShowModal(
          "Error al usar el proceso",
          "No se pudo clonar el proceso al espacio de trabajo.",
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
        return;
      }

      const nuevoIdProceso = response.Data["Id"];

      // redirigir a "Diseño de Procesos" abriendo el proceso recién clonado.
      // El wrapper de design-process (BSPFrontEnd/components/diagram) carga un iframe con
      // src = AppData.DIAGRAM_URL; hay que fijarlo ANTES de navegar (mismo mecanismo que usa
      // "Editar Proceso" en datatable-procesos.component.ts), si no el iframe queda en blanco.
      AppData.DIAGRAM_URL =
        AppData.DIAGRAM_DATA +
        "?Tipo=proceso&Id=" +
        nuevoIdProceso +
        "&Token=" +
        sessionStorage.getItem(AppData.localStorageToken);

      this.botonProcesando = false;
      this.router.navigate(["home/design-process"]);
    } catch (error) {
      console.error("Error al usar el proceso:", error);
      this.baseService.triggerShowModal(
        "Error al usar el proceso",
        "Ocurrió un error al clonar el proceso al espacio de trabajo.",
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }
}
